export function RenderDriveImg (id) { return `https://drive.google.com/uc?export=view&id=${id}`}